import React, { useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ImpressumModal, DatenschutzModal } from './LegalModals';
type CalendlyThankYouPageProps = {
  onClose: () => void;
};
function ThankYouHeader() {
  return <motion.header className="fixed top-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-md shadow-lg" initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-177">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="flex items-center justify-between h-16 sm:h-20" data-id="element-179">
          <a href="/" className="text-white font-bold text-xl sm:text-2xl tracking-tight" data-id="element-180">
            CR Careers
          </a>
        </div>
      </div>
    </motion.header>;
}
function ThankYouFooter() {
  const [showImpressum, setShowImpressum] = useState(false);
  const [showDatenschutz, setShowDatenschutz] = useState(false);
  return <>
      <footer className="bg-slate-950 border-t border-slate-800" data-id="element-181">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-182">
          <div className="text-center space-y-6" data-id="element-183">
            <div className="text-white font-bold text-2xl mb-4" data-id="element-184">CR Careers</div>

            <div className="flex justify-center gap-6 text-sm text-slate-400" data-id="element-185">
              <button onClick={() => setShowImpressum(true)} className="hover:text-white transition-colors" data-id="element-186">
                Impressum
              </button>
              <span className="text-slate-700" data-id="element-187">|</span>
              <button onClick={() => setShowDatenschutz(true)} className="hover:text-white transition-colors" data-id="element-188">
                Datenschutz
              </button>
            </div>

            <p className="text-slate-400 text-sm" data-id="element-189">
              © {new Date().getFullYear()} CR Careers. All rights reserved.
            </p>
            <p className="text-slate-500 text-xs max-w-3xl mx-auto leading-relaxed" data-id="element-190">
              NOT GOOGLE: This site is not a part of the Google website or
              Google Inc. Additionally, This site is NOT endorsed by Google in
              any way. This site is not a part of the Facebook website or
              Facebook Inc. Additionally, This site is NOT endorsed by Facebook
              in any way. FACEBOOK is a trademark of FACEBOOK, Inc.
            </p>
          </div>
        </div>
      </footer>
      <AnimatePresence data-id="element-191">
        {showImpressum && <ImpressumModal isOpen={showImpressum} onClose={() => setShowImpressum(false)} data-id="element-192" />}
        {showDatenschutz && <DatenschutzModal isOpen={showDatenschutz} onClose={() => setShowDatenschutz(false)} data-id="element-193" />}
      </AnimatePresence>
    </>;
}
export function CalendlyThankYouPage({
  onClose
}: CalendlyThankYouPageProps) {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Load Calendly widget script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      // Cleanup script on unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen w-full bg-slate-900 overflow-x-hidden" data-id="element-194">
      <ThankYouHeader data-id="element-195" />

      <main className="overflow-x-hidden" data-id="element-196">
        <section className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-900 to-slate-800 pt-24 pb-12" data-id="element-197">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-198">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="space-y-8" data-id="element-199">
              {/* Heading */}
              <div className="text-center space-y-4" data-id="element-200">
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white" data-id="element-201">
                  Next schedule your introductory call now!
                </h1>
                <p className="text-lg sm:text-xl text-slate-400" data-id="element-202">
                  Beware appoints can be booked out soon
                </p>
              </div>

              {/* Calendly Widget */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: 0.2,
              duration: 0.5
            }} className="w-full max-w-5xl mx-auto bg-white rounded-2xl overflow-hidden shadow-2xl" data-id="element-203">
                <div className="calendly-inline-widget" data-url="https://calendly.com/hillary-crm-kraft/intro?hide_gdpr_banner=1" style={{
                minWidth: '320px',
                height: '700px'
              }} data-id="element-204" />
              </motion.div>
            </motion.div>
          </div>
        </section>
      </main>

      <ThankYouFooter data-id="element-205" />
    </div>;
}